import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  CloseButton,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { crm } from "../../../theme";
import { Dispatch, SetStateAction, useMemo, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { columns } from "./columns";
import { saveUserPreference, PREF_PROCESS_COLUMNS } from "../../../services/userPreferenceService";

const ColumnsModal = ({
  isOpen,
  onClose,
  selectedColumns,
  setSelectedColumns,
  tags,
}: {
  isOpen: boolean;
  onClose: () => void;
  selectedColumns: string[];
  setSelectedColumns: Dispatch<SetStateAction<string[]>>;
  tags: any[];
}) => {
  const [search, setSearch] = useState("");
  const [saving, setSaving] = useState(false);
  const fixedLabel = columns.find((c) => c.fixed)?.label;

  const sortedColumns = useMemo(
    () => [...columns].sort((a, b) => a.label.localeCompare(b.label, "pt-BR")),
    [],
  );

  const filteredColumns = useMemo(
    () =>
      sortedColumns.filter((c) =>
        c.label.toLowerCase().includes(search.toLowerCase()),
      ),
    [sortedColumns, search],
  );

  const handleToggle = (label: string, checked: boolean) => {
    if (checked) {
      setSelectedColumns((prev) =>
        prev.includes(label) ? prev : [...prev, label],
      );
    } else {
      setSelectedColumns((prev) => prev.filter((l) => l !== label));
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await saveUserPreference(PREF_PROCESS_COLUMNS, selectedColumns);
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay backdropFilter="blur(2px)" bg="blackAlpha.600" />
      <ModalContent borderRadius="16px" boxShadow="0 12px 32px rgba(16,24,40,0.18)">
        <ModalHeader borderBottom={crm.border}>
          <Flex w="100%" justifyContent="space-between" alignItems="center">
            <Heading fontSize="lg">Personalizar colunas</Heading>
            <CloseButton onClick={onClose} />
          </Flex>
        </ModalHeader>
        <ModalBody>
          <InputGroup mb="16px">
            <InputLeftElement pointerEvents="none">
              <FaSearch color="gray" />
            </InputLeftElement>
            <Input
              placeholder="Pesquisar coluna..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>
          <Box
            paddingY="16px"
            minHeight="20vh"
            maxHeight="50vh"
            overflowY="scroll"
            paddingLeft="4px"
          >
            {search.length === 0 && (
              <Checkbox
                isChecked={
                  selectedColumns.length > 0 &&
                  columns.every((dd) =>
                    selectedColumns.some((d) => dd.label === d),
                  )
                }
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedColumns(columns.map((c) => c.label));
                  } else {
                    setSelectedColumns(fixedLabel ? [fixedLabel] : []);
                  }
                }}
                mb="24px"
              >
                Selecionar todas
              </Checkbox>
            )}
            <Flex flexDirection="column">
              {filteredColumns.map((e) => (
                <Checkbox
                  key={e.label}
                  isChecked={selectedColumns.includes(e.label)}
                  isDisabled={e.fixed}
                  onChange={(ev) => handleToggle(e.label, ev.target.checked)}
                >
                  {e.label}
                </Checkbox>
              ))}
            </Flex>
          </Box>
        </ModalBody>
        <ModalFooter borderTop={crm.border}>
          <ButtonGroup>
            <Button
              backgroundColor={crm.brand}
              _hover={{ backgroundColor: crm.brandDark }}
              color="white"
              borderRadius="10px"
              onClick={handleSave}
              isLoading={saving}
            >
              Salvar
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ColumnsModal;
